module.exports = __webpack_public_path__ + "static/img/27-北京市海淀北部新区实验学校(小学部)1.5eed05a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/27-北京市海淀北部新区实验学校(小学部)1.png
// module id = gUeI
// module chunks = 0